// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2jvRs","col":"CardReaderDesc_col__3aQJa","label":"CardReaderDesc_label__24Xyr"};